import { css } from "@emotion/react";

export const form = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const marginBottom = css`
  margin-bottom: 1rem;
`;

export const tosContainer = css`
  width: 105%;
`;
